(function () {
  if (window.__shortDescriptionToggleInit) return;
  window.__shortDescriptionToggleInit = true;

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-short-description-toggle]');
    if (!toggle) return;

    const wrapper = toggle.closest('.product-short-description');
    if (!wrapper) return;

    const shortText = wrapper.querySelector('[data-short-description-short]');
    const fullText = wrapper.querySelector('[data-short-description-full]');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    const newExpanded = !expanded;

    shortText.hidden = newExpanded;
    fullText.hidden = !newExpanded;
    toggle.setAttribute('aria-expanded', String(newExpanded));
    toggle.textContent = newExpanded
      ? toggle.getAttribute('data-read-less-label')
      : toggle.getAttribute('data-read-more-label');
  });
})();
